import { Link } from '@tanstack/react-router';
import { dv } from '../i18n/dv.ts';

export function NotFound(): JSX.Element {
  return (
    <div className="p-8 space-y-4">
      <p className="text-sm text-muted-foreground">{dv.notFound.title}</p>
      <Link to="/" className="text-sm underline underline-offset-4">{dv.notFound.home}</Link>
    </div>
  );
}
